import React from 'react';

class Footer extends React.Component {
	render() {
		return (
			<div className="Footer">
					<div className="f-text">Nick Boyd &copy; 2020</div>
			</div>
		);
	}
};

export default Footer;